import {
  Input,
  Output,
  OnDestroy,
  Component,
  EventEmitter,
  TemplateRef,
  AfterContentInit,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { CustomTemplateDirective } from './custom-template.directive';

@Component({
  selector: 'tablesready-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  standalone: false,
})
export class TabsComponent implements OnDestroy, AfterContentInit {
  @ContentChildren(CustomTemplateDirective) customTemplates: QueryList<CustomTemplateDirective>;
  customContent: Record<string, TemplateRef<any>> = {};

  ngAfterContentInit(): void {
    this.customTemplates.forEach((template) => {
      this.customContent[template.appCustomTemplateType] = template.templateRef;
    });
  }

  @Input() showBorder = true;
  @Input() tabs: string[] = [];
  @Input() activeTab: string;
  @Input() boldText = false;
  @Input() paddingVertical = '1rem';
  @Input() disabled = false;
  @Output() changeTab = new EventEmitter<string>();

  ngOnDestroy(): void {
    this.changeTab.complete();
  }

  changeNav(tab: string): void {
    if (!this.disabled) {
      this.changeTab.emit(tab);
    }
  }

  isActiveTab(tab: string): boolean {
    return tab === this.activeTab;
  }
}
